import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 320,
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '600px',
        margin: 'auto'

    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: '10px'
    },
    paperContent: {
        backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 1, 1),
        borderRadius: '10px'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: '80px',
        marginTop: '-5%',
        marginBottom: '3.2%'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));


export default function AlcRP({
    positivos,
    isLoadUser }) {


    const r = positivos.sort((a, b) => a.ies < b.ies ? 1 : -1)
    const clases = useStyles()

    return (
        <>

            {isLoadUser ? <>cargando...</>

                : r.map((row, index) => (
                    <Paper className={clases.card}>
                        <Grid container spacing={1}>
                            <Grid item style={{ width: '15%', paddingLeft: '4%', fontWeight: 'bold', fontSize: '16px' }}>
                                {row.cedula ? row.cedula : '--'}
                            </Grid>
                            <Grid item style={{ width: '22%', paddingLeft: '12%', fontWeight: 'bold', fontSize: '16px' }}>
                                {row.celular}
                            </Grid>
                            <Grid  style={{ width: '25%', paddingLeft: '13%', fontWeight: 'bold', fontSize: '16px' }}>
                                {isNaN(row.alcoholimetria) ? '--' : parseFloat(row.alcoholimetria).toFixed(2)}
                            </Grid>
                            <Grid style={{ width: '30%', paddingLeft: '8%', fontWeight: 'bold', fontSize: '16px' }} >
                                {row.datecreated ? new Date(row.datecreated).toLocaleDateString('es-ES', { day: 'numeric', month: 'numeric', year: 'numeric' }) + ' ' + new Date(row.datecreated).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '--'}
                            </Grid>

                        </Grid>
                    </Paper>
                ))}

        </>
    );
}